<template>
	<div class="footer">
		<div class="container">
			<div class="footer-content">
				<div class="footer-left-content">
					<div class="footer-interval">
						<strong class="footer_main--column_title" >{{ this.navigationList[0] ? this.navigationList[0].navigationName : '产品&技术' }}</strong>
						<div class="footer-link">
							<div class="footer-link-title" v-if="this.navigationList[0]">
								<div class="footer-title-name" v-for="(item,index) in this.navigationList[0].children" @click="toProdect(item)">{{ item.navigationName }}</div>
							</div>
						</div>
					</div>
					<div class="footer-interval">
						<strong class="footer_main--column_title">{{ this.navigationList[1] ? this.navigationList[1].navigationName : '解决方案' }}</strong>
						<div class="footer-link">
							<div class="footer-link-title" v-if="this.navigationList[1]">
								<div class="footer-title-name" v-for="(item,index) in this.navigationList[1].children" @click="toProdect(item)">{{ item.navigationName }}</div>
							</div>
						</div>
					</div>
					<div class="footer-interval">
						<strong class="footer_main--column_title">{{ this.navigationList[2] ? this.navigationList[2].navigationName : '详细信息' }}</strong>
						<div class="footer-link">
							<div class="footer-prodect1-title" v-if="this.navigationList[2]">
								<div class="footer-title-name" v-for="(item,index) in this.navigationList[2].children" @click="toProdect(item)">{{ item.navigationName }}</div>
							</div>
						</div>
					</div>
					<div class="footer-interval">
						<strong class="footer_main--column_title">联系我们</strong>
						<p class="help">如果有任何疑问请联系我们，我们竭诚为你服务</p>
						<p class="phone">0791-88861315</p>
						<div class="code-img">
							<img src="@/assets/er_code.png" />
						</div>
					</div>
				</div>
				<div class="footer-right-content"></div>
			</div>
		</div>
		<div class="footer-corporation">
			<img src="@/assets/police.png" alt="">
			<span class="copy-right" @click="handleToLink">赣ICP备20000694号 南昌惠联网络技术有限公司 版权所有</span>
		</div>
	</div>
</template>

<script>
import logo from '@/assets/logo.png';
import code from '@/assets/er_code.png';
import { handleTree } from "@/utils/admin";
import { queryNavigation } from "@/api/navigation";
export default {
	name: "Footer",
	components: {},
	data(){
		return{
			navigationList: [],
			logo: logo,
			code: code,
		}
	},
	methods: {
		getNavigation() {
			const data = {
				navigationClassify:1
			}
			queryNavigation(data).then(res => {
				this.navigationList = handleTree(res.data, "navigationId", "parentId");
			})
		},
		toProdect(command) {
			if (command.remark) {
				return;
			}
			this.$router.push({
				path: command.link,
				query: {
					navigationId: command.relationId ? command.relationId : command.navigationId
				}
			})
		},
		handleToLink() {
			window.open('https://beian.miit.gov.cn', '_blank');
		}
	},
	name: "Footer",
	beforeDestroy() {

	},
	created() {
		this.getNavigation()
	}
}
</script>

<style lang="scss" scoped>
.footer-line{
	border-bottom: 1px solid #2f3135;
}
.footer-corporation{
	display: flex;
	align-items: center;
	justify-content: center;
	border-top:  1px solid #333333;
	padding: 15px 0;

	img {
		width: 15px;
		height: 15px;
	}

	.copy-right {
		display: inline-block;
		margin-left: 10px;
		cursor: pointer;
		color: rgba(255,255,255,0.7);
		font-size: 14px;
	}
}
.footer-link{
	display: flex;
	justify-content: center;
	color: #fff;
}
.footer-link-title{
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: 0 10px;
}
.footer-prodect1-title {
	width: 100%;
}
.footer-title-name {
	margin-bottom: 20px;
	color: rgba(255,255,255,0.7);
	font-size: 14px;
	white-space: nowrap;
	cursor: pointer; 
}
.footer-title-name:hover {
	color: #0e90d2;
}
.help {
	color: rgba(255,255,255,0.7);
	font-size: 14px;
}
.phone {
	color: #fff;
	font-size: 32px;
	margin-top: 0;
}
.code-img {
	width: 100px;
	height: 100px;

	img {
		width: 100%;
		height: 100%;
	}
}

@media screen and (max-width: 768px) {
	.container {
		display: none !important;
	}
}

@media screen and (min-width: 0) {
	.footer-left-content {
		grid-template-columns: 1fr !important;
	}
	
}
@media screen and (min-width: 768px) {
	.footer-left-content {
		grid-template-columns: 1fr 1fr !important;
	}
	
}
@media screen and (min-width: 1024px) {
	.footer-left-content {
		grid-template-columns: 3fr 3fr 1fr !important;
	}	
}

@media screen and (min-width: 1440px) {
	.footer-left-content {
		grid-template-columns: 3fr 3fr 1fr 2fr !important;
	}	
}
</style>
